import { Badge, BadgeLevel, BadgeShape, BadgeSize } from '@vizit/atoms';

interface AffectedCollectionListProps {
  /** The collections named so far */
  collections: { id: string; name: string }[];
  /** How many there are in all; any beyond the named ones show as "+N more" */
  count: number;
}

/**
 * The collections scored against a benchmark, a chip each, in the confirms that change the benchmark (delete, remove
 * images). Before the names have loaded, "+N more" stands in for every one of them.
 */
function AffectedCollectionList({ collections, count }: AffectedCollectionListProps) {
  const unlistedCount = Math.max(count - collections.length, 0);
  return (
    <ul className="flex flex-wrap gap-2" aria-label="Affected collections">
      {/* Names can be one long word, so they break anywhere rather than run past the dialog. */}
      {collections.map((collection) => (
        <li key={collection.id} className="min-w-0 max-w-full">
          <Badge level={BadgeLevel.Default} shape={BadgeShape.Box} size={BadgeSize.Sm} className="max-w-full">
            <span className="min-w-0 text-xs [overflow-wrap:anywhere]">{collection.name}</span>
          </Badge>
        </li>
      ))}
      {unlistedCount > 0 && (
        <li>
          <Badge level={BadgeLevel.Default} shape={BadgeShape.Box} size={BadgeSize.Sm}>
            <span className="text-xs">+{unlistedCount} more</span>
          </Badge>
        </li>
      )}
    </ul>
  );
}

export { AffectedCollectionList };
export type { AffectedCollectionListProps };
